import * as stylex from "@stylexjs/stylex";
import "@/theme/tokens.stylex";
import { colors, motion, radii } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
type PillOption<T extends string> = T | {
  value: T;
  label: string;
};
type PillTabsProps<T extends string> = {
  options: readonly PillOption<T>[];
  value: T;
  onChange: (value: T) => void;
  label?: string;
  size?: "md" | "lg";
  xstyle?: stylex.StyleXStyles;
};
const styles = {
  list: {
    kMzoRj: "xc342km",
    kogj98: "x1ghz6dp",
    k7Eaqz: "xeuugli",
    k1xSpc: "x3nfvp2",
    kOIVth: "x1jnr06f",
    kmVPX3: "xfawy5m",
    kaIpWk: "x87fg2h",
    kWkggS: "xh540kj",
    $$css: true
  },
  wrap: {
    kwnvtZ: "x1a02dak",
    ks0D6T: "x193iq5w",
    kB7OPa: "x9f619",
    kaIpWk: "x350i8",
    $$css: true
  },
  tab: {
    kMzoRj: "xc342km",
    kkrTdU: "x1ypdohk",
    kaIpWk: "x87fg2h",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1a11ngh",
    kMv6JI: "x17jlq2w",
    k63SB2: "xdx46lq",
    kb6lSQ: "x8mdbtd",
    kLWn49: "x1u7k74",
    k1ekBW: "xs2xxs2",
    kIyJzY: "x16c7our",
    kAMwcw: "x1em5f5i",
    $$css: true
  },
  md: {
    k8WAf4: "x1vvogim",
    kg3NbH: "x12j899k",
    kAzted: "x1ba4aug",
    kGuDYH: "xgf3mmf",
    $$css: true
  },
  lg: {
    k8WAf4: "xxlmvz2",
    kg3NbH: "x1pbfunf",
    kAzted: "xbktkl8",
    kGuDYH: "x1i1m3gp",
    $$css: true
  },
  selected: {
    kWkggS: "xfenp3h",
    kMwMTN: "xnnvkky",
    $$css: true
  }
};
export function PillTabs<T extends string>({
  options,
  value,
  onChange,
  label,
  size = "md",
  xstyle
}: PillTabsProps<T>) {
  return <fieldset aria-label={label} {...stylex.props(styles.list, size === "lg" && styles.wrap, xstyle)}>
      {options.map(normalize).map(option => {
      const selected = option.value === value;
      return <button key={option.value} type="button" aria-pressed={selected} onClick={() => onChange(option.value)} {...stylex.props(styles.tab, styles[size], selected && styles.selected)}>
            {option.label}
          </button>;
    })}
    </fieldset>;
}
function normalize<T extends string>(option: PillOption<T>) {
  return typeof option === "string" ? {
    value: option,
    label: option
  } : option;
}